import { ProductoStockEstado } from 'src/utils/enums/ProductoStockEstado';
import { ProductoStockFormState } from './types';

import {} from './apiThunk';
import { RootState } from 'src/app/store';
import { createSlice } from '@reduxjs/toolkit';

const initialState: ProductoStockFormState = {
  data: null,
  status: null,
  actions: null,
  previousState: undefined,
};

const formSlice = createSlice({
  name: 'productoStockForm',
  initialState,
  reducers: {
    resetForm(state) {
      state.data = null;
      state.status = null;
      state.actions = null;
      state.previousState = null;
    },

    setFormStatusVencido(state) {
      state.status = {
        id: ProductoStockEstado.Vencido,
        text: ProductoStockEstado[ProductoStockEstado.Vencido].toUpperCase(),
        color: '#70BDFF',
      };
      state.actions = {
        guardar: {
          visible: true,
          disabled: false,
          tooltip: 'Guardar',
        },
      };
    },
    setFormStatusAgotado(state) {
      state.status = {
        id: ProductoStockEstado.Agotado,
        text: ProductoStockEstado[ProductoStockEstado.Agotado].toUpperCase(),
        color: '#70BDFF',
      };
      state.actions = {
        guardar: {
          visible: true,
          disabled: false,
          tooltip: 'Guardar',
        },
      };
    },
    setFormStatusEnStock(state) {
      state.status = {
        id: ProductoStockEstado.EnStock,
        text: ProductoStockEstado[ProductoStockEstado.EnStock].toUpperCase(),
        color: '#70BDFF',
      };
      state.actions = {
        guardar: {
          visible: true,
          disabled: false,
          tooltip: 'Guardar',
        },
      };
    },
  },
  extraReducers: (builder) => {},
});
// Selectors

export const selectFormStatus = (state: RootState) =>
  state.productoStock.form.status;
export const selectGuardar = (state: RootState) =>
  state.productoStock.form.actions?.guardar;

// Export actions
export const {
  resetForm,

  setFormStatusVencido,
  setFormStatusAgotado,
  setFormStatusEnStock,
} = formSlice.actions;

export default formSlice.reducer;
